import { gql } from '@apollo/client';

export const GET_VOLUNTEER_CERTIFICATES = gql`
  query GetVolunteerCertificates($volunteerId: String!) {
    vm {
      volunteer(volunteerId: $volunteerId) {
        volunteerId
        certificates {
          volunteerCertificateId
          templateName
          awardedFor
          issuedAt
          issuedBy {
            volunteerId
            profile {
              profileId
              preferredName
              lastName
            }
          }
          awardedAchievement {
            awardedAchievementId
            source
          }
        }
      }
      certificateTemplates {
        certificateTemplateId
        name
      }
    }
  }
`;
